import { action as a, createAction } from "./actions";

export const handleDispatch =
  (dispatch) =>
  (action = a.notSpecified, meta = undefined) =>
  (payload) => {
    const extendedAction = meta ? { ...action, meta } : action;
    return dispatch(createAction(extendedAction, payload));
  };
